import { set, toggle } from '@/utils/vuex'

export default {
  clearNewManagedServices (state) {
    state.newManagedServices = {
      ...state.newManagedServices,
      registrationStep: 'listing', // ie, listing, validation, onboarding, contact
      searching: false,
      searchMessage: '',
      searchError: false,
      selected: false,
      AWS_Accounts: '',
      AWS_Regions: [],
      Client_Email_List: [],
      Offering_Access_Email: []
    }
  },
  clearManagedServicesList (state) {
    state.managedServicesList = {
      // ...state.managedServicesList,
      selectedWorkload: [],
      loadingWorkloads: false,
      workloads: []
    }
  },
  loadData (state, customers) {
    state.customers = customers
  },
  setSearchSfdcId (state, id) {
    state.newManagedServices = {
      ...state.newManagedServices,
      sfdcId: id
    }
  },
  setLoadingWorkloads (state, searching) {
    state.managedServicesList.loadingWorkloads = searching
  },
  setListType (state, type) {
    state.managedServicesList.listType = type
  },
  setLoadingList (state, load) {
    state.managedServicesList.loadingList = load
  },
  setSearchResponse (state, response) {
    state.newManagedServices = {
      ...state.newManagedServices,
      searchError: response.error,
      searchMessage: response.message
    }
  },
  setWorkloadRecord (state, workload) {
    state.newManagedServices = {
      ...state.newManagedServices,
      ...workload
    }
  },
  // setWorkloadCustName (state, customername){
  //   state.awsAccountOnboarding.fields = {
  //     ...state.awsAccountOnboarding.fields, 
  //     ...customername
  //   }
  // },
  setWorkloads (state, workloads) {
    console.log('setWorkloads', workloads)
    state.managedServicesList = {
      ...state.managedServicesList,
      workloads: workloads
    }
  },
  loadList (state, list) {
    if (state.managedServicesList.nextPaginationKey) {
      state.managedServicesList.listManagedServices = [
        ...state.managedServicesList.listManagedServices,
        ...list
      ]
    } else {
      state.managedServicesList.listManagedServices = list
    }
  },
  loadCustomers (state, customers) {
    state.customers = customers
  },
  setSelectedWorkload (state, workload) {
    let selWorkload = workload.length ? [workload.slice(-1)[0]] : []
    state.managedServicesList = {
      ...state.managedServicesList,
      selectedWorkload: selWorkload
    }
  },
  awsAccountList (state, account) {
    state.awsAccountList = account
  },
  resetWbsValidation (state) {
    state.awsAccountValidation = {
      ...state.awsAccountValidation,
      wbsValidating: false,
      wbsValidationMessage: '',
      wbsCodeValidated: false,
      wbsType: null,
      iwoCode: null,
      iwoValidating: false,
      iwoValidationMessage: '',
      iwoCodeValidated: false,
      agreed: false,
      submitting: false,
      savingForLater: false
    }
  },
  setWbsCodeValidating (state, loading) {
    state.awsAccountValidation = {
      ...state.awsAccountValidation,
      wbsValidating: loading
    }
  },
  setWbsValidationResponse (state, response) {
    if (response.valid) {
      state.awsAccountValidation = {
        ...state.awsAccountValidation,
        wbsCodeValidated: true,
        wbsValidationMessage: response.message,
        wbsType: response.type
      }
    } else {
      state.awsAccountValidation = {
        ...state.awsAccountValidation,
        wbsCodeValidated: false,
        wbsType: '',
        wbsValidationMessage: response.message
      }
    }
  },
  setSubmitLoader (state, loading) {
    console.log('setSubmitLoader', loading)
    state.submitLoading = loading
  },
  showUpdateDialog (state, data) {
    state.updateManagedServices.data = data
    state.updateManagedServices.showDialog = true
    state.awsAccountValidation.wbsCode = data.WBS_Code
    state.awsAccountValidation.wbsType = data.WBS_Type
    state.updateManagedServices.data.AWS_Accounts = data.AWS_Accounts
    // state.updateManagedServices.data.AWS_Accounts = data['AWS_Accounts'].split(',')
    state.updateManagedServices.data.AWS_Regions = data['AWS_Regions'].split(',')
  },
  closeDialog (state, data) {
    state.updateManagedServices.data = {}
    state.updateManagedServices.showDialog = false
    state.awsAccountValidation.wbsCode = ''
    state.awsAccountValidation.wbsType = ''
  },
  setNextPageKey (state, data) {
    state.managedServicesList.nextPaginationKey = data
  }
}
